import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import ThankReferrerButton from "@/components/ThankReferrerButton";

const STATUS = { active: "unused", applied: "on next renewal", used: "redeemed", replaced: "replaced" };

export default function ReferralLeaderboard({ api }) {
  const [leaders, setLeaders] = useState(null);
  useEffect(() => {
    api.get("/admin/referral-leaderboard").then(({ data }) => setLeaders(data.leaders)).catch(() => setLeaders("error"));
  }, [api]);
  if (!leaders) return null;
  const onIssued = (uid, t) => setLeaders((ls) => ls.map((l) => (l.user_id === uid ? { ...l, last_thanks: t } : l)));
  return (
    <section className="brutal-border p-4 sm:p-5 mb-8" data-testid="referral-leaderboard">
      <div className="font-mono-label text-[10px] text-muted-foreground inline-flex items-center gap-1.5 mb-3">
        <Trophy size={12} className="text-[#FFD600]" /> TOP REFERRERS
      </div>
      {leaders === "error" ? (
        <p className="text-sm text-[#F87171]" data-testid="referral-leaderboard-error">Could not load top referrers. Refresh to try again.</p>
      ) : leaders.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="referral-leaderboard-empty">No paid referrals yet. Your top 5 referrers will show here.</p>
      ) : (
        <ol className="divide-y divide-[#262626]">
          {leaders.map((l, i) => (
            <li key={l.user_id} className="py-3 flex flex-col sm:flex-row sm:items-center gap-3" data-testid={`leader-row-${i + 1}`}>
              <div className="font-heading font-black text-2xl w-8 text-[#FFD600]">{i + 1}</div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold truncate" data-testid={`leader-name-${i + 1}`}>{l.name || l.legal_name || l.email || "Unnamed client"}</div>
                <div className="text-xs text-muted-foreground truncate">{l.email}</div>
                {l.last_thanks && (
                  <div className="text-[11px] text-[#4ADE80] mt-0.5" data-testid={`leader-last-thanks-${i + 1}`}>
                    Last thank-you: {l.last_thanks.pct}% · {l.last_thanks.code} · {STATUS[l.last_thanks.status] || l.last_thanks.status}
                  </div>
                )}
              </div>
              <div className="text-sm sm:text-right" data-testid={`leader-count-${i + 1}`}>
                <b>{l.referrals}</b> paid referral{l.referrals === 1 ? "" : "s"}
                <div className="text-xs text-muted-foreground">${(l.earned_cents / 100).toFixed(0)} credit earned</div>
              </div>
              <ThankReferrerButton api={api} leader={l} index={i + 1} onIssued={onIssued} />
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
